// JavaScript Document
//components/signs/Stats
import React from 'react';
import { makeStyles, MuiThemeProvider, createTheme as createMuiTheme } from '@material-ui/core/styles';
//import { MuiThemeProvider, CreateMuiTheme} from '@materia'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { DateRangePicker } from 'materialui-daterange-picker';
import { Button, Dialog, Box, Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@material-ui/core';
import moment from 'moment';
import Skeleton from '@material-ui/lab/Skeleton';
import { CloudUpload as IconUpload, DateRange as IconDate, Menu as IconMenu, FolderOpen as IconFiles, GetApp as IconDownload } from '@material-ui/icons';
import { DropzoneDialog } from 'material-ui-dropzone';
import { Link } from 'react-router-dom';
import SummaryTable from './stats/Summary';
import Chart from './stats/Chart';
import HourTable from './stats/HourTable';
import UserNotice from '../core/UserNotice';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
}));

const dztheme = createMuiTheme({
	overrides: {
		MuiDropzonePreviewList : {
			image : { display: 'none'}

		}
	}
})




export default function SignStats(props) {
	const classes = useStyles();
	const {handleSend, sign} = props;
	const [loaded, setLoaded] = React.useState(false);
	const [stats, setStats] = React.useState([]);
	const [summary, setSummary] = React.useState({});
	const [hourData, setHourData] = React.useState([]);
	const [rangeOpen, setRangeOpen] = React.useState(false);
	//const [rangeDialogOpen, setRangeDialogOpen] = React.useState(false);
	const [dateRange, setDateRange] = React.useState({});
	const [minDate, setMinDate] = React.useState(new Date(Date.now() - 1000 * 60 * 60 * 24 * 365));
	const [maxDate, setMaxDate] = React.useState(new Date());
	const [isLoaded, setIsLoaded] = React.useState(false);
	const [statusMsg, setStatusMsg] = React.useState('loading stats');
	const [signId, setSignId] = React.useState(0);
	const [uploadOpen, setUploadOpen] = React.useState(false);
	const [statMenuAnchor, setStatMenuAnchor] = React.useState(null);
	const [errorOpen, setErrorOpen] = React.useState(false);
	const [successOpen, setSuccessOpen] = React.useState(false);
	const [errorMessage, setErrorMessage] = React.useState('');
	const [successMessage, setSuccessMessage] = React.useState('');
	
	const statlimits = [
		{
			type : 'xls',
			limit: 65532,
		},
		{
			type : 'csv',
			limit: 1048576
		},
		{
			type : 'csv',
			limit: 0
		}
	];

	const getDownloadType = (total) => {
		for(let tl of statlimits){
			if (tl.limit === 0) return tl;
			if (total < tl.limit) return tl;
		}
	}

  	const [mySign, setMySign] = React.useState({
		sign_type_obj:{},
		options:[],
		geo_location: '-117.8027955, 33.86.25262',
	});

	const menuOrigin = {
		vertical : 'top',
		horizontal : 'right'
	}

   	React.useEffect(() => {
		//console.log('overview effect');
		//console.log('Loaded: ' + loaded);
		//console.log('SignId: ' + signId);
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			setMySign(sign);
		}
		if(!loaded && signId){
			getStats();
		} 
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props, signId]);

 	const getStats = () => {
		//console.log('loading services');
	  	setLoaded(true);
	  	handleSend({
		  	vso: 'stats',
		  	sign: signId
	  	}, (data) => {
			setIsLoaded(true);
			updateStats(data.stats, true);
		});
	}

	const updateStats = (stats, setRange) => {
		if(stats.daily) setHourData(stats.daily);
		if(stats.message) setStatusMsg(stats.message);
		if(stats.raw) setStats(stats.raw);
		if(stats.summary) setSummary(stats.summary);
		if(setRange){
			if(stats.summary) setDateRange({
				startDate : toDateObj(stats.summary.startDate),
				endDate : toDateObj(stats.summary.endDate)
			});
			if(stats.limit && stats.limit.min) setMinDate(toDateObj(stats.limit.min));
			if(stats.limit && stats.limit.max) setMaxDate(toDateObj(stats.limit.max));
		}
		
	}

	const handleClickDate = () => {
		setRangeOpen(true);
		//setRangeDialogOpen(true);
	}

	const toDateObj = (string) => {
		let [year, month, day] = string.split('-').map(n => parseInt(n));
		return new Date(year, month - 1, day);
	}
	
	const compileSummaryItems = () => {
		if(Object.keys(summary).length === 0){
			//it's empty
			return [];
		}
		var items = [];
		if(summary.speed_limit){
			items.push({
				name: 'Speed Limit',
				value: summary.speed_limit
			});
			items.push({
				name: 'Average MPH over limit',
				value: summary.average_mph_over_limit
			});
			items.push({
				name: 'Total Speeders',
				value: summary.total_speeders
			});
			items.push({
				name: 'Total exeeding limit by ' + summary.speed_threshold + 'mph',
				value: summary.total_exceeding_threshold
			});
		}
		if(summary.total_count > 0)
			items.push({
				name: 'Total Records',
				value: summary.total_count
			});
		items.push({
			name: summary.percentile + 'th Percentile',
			value: summary.percentile_speed
		});
		items.push({
			name: 'Total exceeding ' + summary.percentile_speed + 'mph',
			value: summary.total_exceeding_percentile
		});
		items.push({
			name: 'Date Range',
			value: prettyDate(summary.startDate)+' - '+prettyDate(summary.endDate)
		})
		return items;
	}
	const prettyDate = (string) => {
		if(!string) return string;
		//let [year, month, day] = [2023, 5, 5];
		let year = 2023;
		if(typeof string === 'string') {
			[year//, month, day
			] = string.split('-', 1).map(n => parseInt(n));
		} else {
			year = string.getFullYear();
		}
		if(year === (new Date()).getFullYear()) return moment(string).format('M/D');
		return moment(string).format('M/D/YYYY');
	}
	
	const renderStats = () => {
		//stats to display
		if(stats.length === 0){
			//no stats loaded
			if(isLoaded)
			return (
				<Typography variant="h5" gutterBottom>
					{statusMsg}
				</Typography>
			);
			//loading
			return (
				<Skeleton variant='rect' height={500} />
			);
		}
		return (
			<Chart items={stats} summary={summary} />
		)
	}

	const toggleRangeOpen = () => {
		handleUpdateRange();
		setRangeOpen(!rangeOpen);
	}


	const handleUpdateRange = () => {
		if(!rangeOpen) return false;
		if(summary.startDate === moment(dateRange.startDate).format('YYYY-MM-DD')
			&& summary.endDate === moment(dateRange.endDate).format('YYYY-MM-DD')
		) return false;
		console.log('THE DATE RANGE WAS CHANGED',
			 summary.startDate, ' != ',
			 moment(dateRange.startDate).format('YYYY-MM-DD'), ' OR ',
			summary.endDate, ' != ',
			 moment(dateRange.endDate).format('YYYY-MM-DD'));
		setIsLoaded(false);
		handleSend({
			vso: 'stats',
			sign: signId,
			startDate : moment(dateRange.startDate).format('YYYY-MM-DD'),
			endDate : moment(dateRange.endDate).format('YYYY-MM-DD')
		}, (data) => {
			setIsLoaded(true);
			updateStats(data.stats);
		});
	}

	const handleClickUpload = (e) => {
		//console.log('you clicked me');
		closeStatMenu();
		setUploadOpen(true);
	}
	const handleCloseUpload = (e) => {
		console.log('you closed dropzone');
		setUploadOpen(false);
	}
	const handleSaveUpload = (files) => {
		console.log('files:', files);
		setUploadOpen(false);
		handleUpload(files);
		//here's where we do some server thing
	}

	const handleUpload = (files, callback) => {
		let url = window.location.origin+'/admin.php?action=vso&ajax=app';
		//url = window.location.origin+'/testfileupload.php';
		let formdata = new FormData();
		formdata.append('vso', 'stats');
		formdata.append('sign', signId);
		formdata.append('subaction', 'upload');
		for(let file of files){
			formdata.append('files[]', file);
		}
		//formdata.append('files', files);
		fetch(url, {
			  method:'POST',
			  credentials: 'include',
			  headers: {
				  //'Content-Type':'application/json',
				  'Accept':'application/json'
			  },
			  body: formdata
			}).then((response) => {
				//console.log('we got a response', response);
				return response.json();
			}).then((data) => {
				console.log(data);
				if(data.error){
					console.log("we received an error");
					console.log(data.error);
					setErrorMessage(data.error);
					setErrorOpen(true);
					//handleError(data.error);
					
				} else {
					if(data.successMessage){
						console.log(data.successMessage);
						setSuccessOpen(true);
						setSuccessMessage(data.successMessage);
					}
					if(callback){
						callback(data);
					}
				}
			});
	  };

	  const closeStatMenu = () => {
		setStatMenuAnchor(null);
	  }

	  /*
	  const handleClickFiles = () => {
		console.log('you wanna see my files');
		closeStatMenu();
	  }
	  */

	  const handleDownloadStats = (isSummary) => {
		//get the download file type based on data limit
		let type = getDownloadType(summary.total_count);
		//compile the query string for download url
		let statvars = [
			'action=vspeed',
			'aset=stats',
			'subaction=download',
			'fdate='+moment(dateRange.startDate).format('YYYY-MM-DD'),
			'tdate='+moment(dateRange.endDate).format('YYYY-MM-DD'),
			'id='+sign.id,
			'limit='+summary.total_count,
			'type='+(isSummary ? 'summarytable' : '')
		].join('&');

		console.log('query string', statvars);

		//compile the filename for download
		var downloadFileName = [
			sign.location, 
			moment(dateRange.startDate).format('YYYY-MM-DD'),
			moment(dateRange.endDate).format('YYYY-MM-DD'),
			isSummary ? 'Summary' : 'Raw'
		].join('_')+'.'+type.type;

		//download URL of stat file
		let StatLocation = window.location.origin + 
			'/needs/vspeedOnline/cfgDownload.php?' + statvars;
		//load stats
		fetch(StatLocation).then(statfile => {
			//convert to blob
			statfile.blob().then(blob => {
				//push blob content as download to browser
				let url = window.URL.createObjectURL(blob);
				let a = document.createElement('a');
				a.href = url;
				a.download = downloadFileName
				a.click();
			});
		});	
		
		closeStatMenu();
	}
	  //download location
	  //$("#downloadFrame").attr("src", "needs/vspeedOnline/cfgDownload.php?action=vspeed&aset=stats&subaction=download&fdate="+fdate+"&tdate="+tdate+"&id="+sign_id+"&type="+type+"&limit="+reclimit);
		
	

	return (
		<div className={classes.root}>
			<Dialog open={rangeOpen}>
			
				<DateRangePicker
					open={rangeOpen}
					toggle={toggleRangeOpen}
					onChange={(range) => setDateRange(range)}
					initialDateRange={dateRange}
					minDate={minDate}
					maxDate={maxDate}
					definedRanges={[]}
				/>
				
			</Dialog>
			<MuiThemeProvider theme={dztheme}>
				<DropzoneDialog
					dialogTitle="Upload SPL and ANL files"
					acceptedFiles={['.txt', '.dat']}
					open={uploadOpen}
					onClose={handleCloseUpload}
					onSave={handleSaveUpload}
					showPreviews={false}
					showPreviewsInDropzone={true}
					showFileNamesInPreview={true}
					showFileNames={true}
					submitButtonText='Upload'
					filesLimit={500}
					dropzoneText="Drag and drop files here or click"
				/>
			</MuiThemeProvider>
			<Menu
				id="stat-menu"
				anchorEl={statMenuAnchor}
				anchorOrigin={menuOrigin}
				keepMounted
				transformOrigin={menuOrigin}
				open={Boolean(statMenuAnchor)}
				onClose={closeStatMenu}
			>
				<MenuItem onClick={handleClickUpload}>
					<ListItemIcon><IconUpload /></ListItemIcon>
					<ListItemText>Upload</ListItemText>
				</MenuItem>
				<MenuItem component={Link} to={"/statfiles/"+sign.id}>
					<ListItemIcon><IconFiles /></ListItemIcon>
					<ListItemText>File History</ListItemText>
				</MenuItem>
				<MenuItem onClick={(e) => handleDownloadStats()}>
					<ListItemIcon><IconDownload /></ListItemIcon>
					<ListItemText>Download Raw Data</ListItemText>
				</MenuItem>
				<MenuItem onClick={e => handleDownloadStats(true)}>
					<ListItemIcon><IconDownload /></ListItemIcon>
					<ListItemText>Download Summary</ListItemText>
				</MenuItem>

			</Menu>
			<Paper className={classes.paper} component="div">
				<Grid container spacing={3}>
					<Grid item xs={12} sm={5}>
						<Typography variant="h5" gutterBottom>
							{mySign.location}
	  					</Typography>
	  					<Typography variant="body2" gutterBottom>
	  		  	  			{mySign.description}
	  					</Typography>
						<Box display="flex">
							<Button color='primary' variant='contained' startIcon={<IconDate />} fullWidth onClick={handleClickDate}>{prettyDate(dateRange.startDate)} - {prettyDate(dateRange.endDate)}</Button>
							<IconButton color='default' variant='contained' onClick={(e) => setStatMenuAnchor(e.currentTarget)} ><IconMenu /></IconButton>
						</Box>
						{isLoaded ? (<SummaryTable items={compileSummaryItems()} />)
						: (<Skeleton variant='rect' height={398} />)}
	  	  	  		</Grid>
					<Grid item xs={12} sm={7}>
						{renderStats()}
					</Grid>
					<Grid item xs={12}>
						{isLoaded ? (<HourTable items={hourData} />) : (<Skeleton variant='rect' height={300} />)}
					</Grid>
	    		</Grid>
	  	  	</Paper>
				<UserNotice
	  				errorOpen={errorOpen}
	    			setErrorOpen={setErrorOpen}
	    			error={errorMessage}
	    			successOpen={successOpen}
	    			setSuccessOpen={setSuccessOpen}
	    			message={successMessage}
	  			/>
		</div>
	);
}
